import { apiClient } from "./api";

export interface FileRecord {
  key: string;
  filename: string;
  size: number;
  last_modified: string;
  url: string;
}

export async function uploadFile(file: File, folder = ""): Promise<{
  key: string;
  filename: string;
  content_type: string;
  size: number;
  url: string;
}> {
  const formData = new FormData();
  formData.append("file", file);
  const params = folder ? `?folder=${encodeURIComponent(folder)}` : "";
  const response = await apiClient.post(`/files/upload${params}`, formData, {
    headers: { "Content-Type": "multipart/form-data" },
  });
  return response.data;
}

export async function listFiles(folder = ""): Promise<FileRecord[]> {
  const response = await apiClient.get("/files", {
    params: folder ? { folder } : undefined,
  });
  return response.data;
}

export async function deleteFile(key: string): Promise<{ status: string; key: string }> {
  const response = await apiClient.delete(`/files/${encodeURIComponent(key)}`);
  return response.data;
}

export async function getFileUrl(key: string): Promise<{ key: string; url: string }> {
  const response = await apiClient.get(`/files/${encodeURIComponent(key)}/url`);
  return response.data;
}
